import * as React from "react";
import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  
} from "@fluentui/react-components";

interface AcceptRevisionsModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const AcceptRevisionsModal: React.FC<AcceptRevisionsModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Modifiche Rilevate</DialogTitle>
          <DialogContent>
            Sono state rilevate modifiche tracciate nel documento. Vuoi accettarle tutte
            prima di procedere con il caricamento/aggiornamento del documento?
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={onCancel}>
              Annulla
            </Button>
            <Button appearance="primary" onClick={onConfirm}>
              Accetta e Continua
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};